@if (item(); as item) {
  <div class="flex flex-col">
    <a
      role="button"
      tabindex="0"
      (keydown.enter)="navigate.emit(item)"
      (click)="navigate.emit(item)"
      class="h-[var(--toolbar-height)] flex items-center px-4 no-underline"
      [ngClass]="{
        'popover-item text-white cursor-pointer': !item.SubItems,
        'text-xs text-light-500 dark:text-dark-200': item.SubItems,
      }"
      [class.disabled]="item.SubItems">
          {{ item.RouteDefinition.title }}
    </a>

    @if (item.SubItems) {
      @for (subItem of item.SubItems; track subItem.Id) {
        <a
          role="button"
          tabindex="0"
          (keydown.enter)="navigate.emit(subItem)"
          (click)="navigate.emit(subItem)"
          class="popover-item h-[var(--toolbar-height)] flex items-center px-4 text-white cursor-pointer no-underline"
          [class.bg-main-blue]="subItem.selected">
              {{ subItem.RouteDefinition.title }}
        </a>
      }
    }
  </div>
}
